import { createContext, useContext, useEffect, useState } from 'react'

const ParentShipmentContext = createContext()

export const useParentShipment = () => useContext(ParentShipmentContext)

export const ParentShipmentProvider = ({ driverCode, children }) => {
    const [parentShipmentObject, setParentShipmentObject] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        if (!driverCode) return
        fetch(
            `https://api.shippersedge.com/v4/shipment/driverCode/${driverCode}?include=stopDetails,supplier,details,handlingUnits,customfields`,
            { headers: { 'x-api-key': 'vdhy8wwjUJrwhxFpfuECTiAW' } }
        )
            .then(res => res.json())
            .then(data => {
                // console.log('ParentShipmentProvider fetched data', data)
                setParentShipmentObject(data)
                setLoading(false)
            })
            .catch(err => {
                setError(err)
                setLoading(false)
            })
    }, [driverCode])

    return (
        <ParentShipmentContext.Provider value={{ parentShipmentObject, loading, error }}>
            {children}
        </ParentShipmentContext.Provider>
    )
}
